// extracted by mini-css-extract-plugin
module.exports = {"icon":"radio-group_icon__C5jwT"};